import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { cn } from '../utils/cn';

const Toggle = ({ 
  items = [], 
  value, 
  onChange,
  className 
}) => {
  return (
    <ToggleGroup.Root
      type="single"
      value={value}
      onValueChange={(value) => value && onChange?.(value)}
      className={cn(
        "h-16 bg-white rounded-md border border-[#dddddd] flex relative",
        className
      )}
    >
      {items.map((item, index) => (
        <ToggleGroup.Item
          key={item.value}
          value={item.value}
          disabled={item.disabled}
          className={cn(
            "relative h-16 cursor-pointer flex-1 focus:outline-none top-[-1px]",
            index < items.length - 1 && "border-r border-r-[#dddddd]",
            "data-[state=on]:before:absolute data-[state=on]:before:inset-x-[-1px] data-[state=on]:before:inset-y-0 data-[state=on]:before:border data-[state=on]:before:border-[#111111] data-[state=on]:before:content-['']",
            index === items.length - 1 && "data-[state=on]:before:rounded-r-md",
            index === 0 && "data-[state=on]:before:rounded-l-md",
            item.disabled && "cursor-not-allowed"
          )}
        >
          <div className="px-2 py-3">
            <div className={"text-center text-sm font-medium leading-[21px]"}>
              {item.label}
            </div>
            <div className="text-center text-[#aaaaaa] text-sm font-normal leading-[21px]">
              {item.subLabel}
            </div>
          </div>
        </ToggleGroup.Item>
      ))}
    </ToggleGroup.Root>
  );
};

export default Toggle; 